import type { RenderEditCellProps } from "react-data-grid";
import type { EditableFieldConfig } from "../editableFields";
import type { TopBuildingsListRow } from "../TopBuildingsList";
import { NumericCellEditor } from "./NumericCellEditor";
import { MoneyCellEditor } from "./MoneyCellEditor";
import { DropdownCellEditor } from "./DropdownCellEditor";
import { TextCellEditor } from "./TextCellEditor";

type Props = RenderEditCellProps<TopBuildingsListRow> & {
  config: EditableFieldConfig;
  onSave: (value: string | number | null) => Promise<boolean>;
};

export function EditableCellRouter({ config, onSave, ...props }: Props) {
  switch (config.type) {
    case "numeric":
      return (
        <NumericCellEditor
          {...props}
          config={config}
          onSave={onSave as (v: number | null) => Promise<boolean>}
        />
      );
    case "money":
      return (
        <MoneyCellEditor
          {...props}
          onSave={onSave as (v: number | null) => Promise<boolean>}
        />
      );
    case "dropdown":
      return (
        <DropdownCellEditor
          {...props}
          config={config}
          onSave={onSave as (v: string) => Promise<boolean>}
        />
      );
    case "text":
    default:
      return (
        <TextCellEditor
          {...props}
          onSave={onSave as (v: string | null) => Promise<boolean>}
        />
      );
  }
}
